// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"N2-z","dimensionLabel":"O2-z","styleChooserControlWrapper":"P2-z","styleChooserControl":"Q2-z","disabled":"R2-z","giftCard":"S2-z","styleChooserText":"T2-z"};